export default __webpack_public_path__ + "static/media/register_contrata.0146b33c.png";